"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_FACTION: function() {
        return ADD_FACTION;
    },
    DELETE_FACTION: function() {
        return DELETE_FACTION;
    },
    DUPLICATE_FACTION: function() {
        return DUPLICATE_FACTION;
    },
    GENERATE_FACTIONS: function() {
        return GENERATE_FACTIONS;
    },
    RESET_FACTIONS: function() {
        return RESET_FACTIONS;
    },
    UPDATE_FACTION: function() {
        return UPDATE_FACTION;
    }
});
const ADD_FACTION = "ADD_FACTION";
const UPDATE_FACTION = "UPDATE_FACTION";
const DELETE_FACTION = "DELETE_FACTION";
const GENERATE_FACTIONS = "GENERATE_FACTIONS";
const RESET_FACTIONS = "RESET_FACTIONS";
const DUPLICATE_FACTION = "DUPLICATE_FACTION";
